import PropTypes from 'prop-types'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'
import ApiClient from 'data/api/api_client'
import CarouselSimilarProperties from 'components/carousels/CarouselSimilarProperties'
import Headers from 'components/home/common/typography/Headers'
import { PropertyPageSections } from 'components/property/PropertyNavbar'

const SimilarPropertiesSection = ({ propertySlugOrId }) => {
  const router = useRouter()

  const { arrival } = router.query
  const { departure } = router.query

  const { data: similarProperties } = useQuery(
    ['similarProperties', propertySlugOrId],
    () => ApiClient.properties.getSimilarProperties(propertySlugOrId, {
      arrival,
      departure,
    }),
  )

  if ((similarProperties ?? []).length === 0) {
    return null
  }

  return (
    <div
      id={PropertyPageSections.SIMILAR_PROPERTIES}
      className="relative justify-center w-full h-full my-100"
    >
      <Headers.XXL className="text-center mb-50 px-30 text-grey-900">
        Similar Properties
      </Headers.XXL>
      {
        similarProperties && (
          <div className="max-w-[1450px] mx-auto">
            <CarouselSimilarProperties similarProperties={similarProperties} />
          </div>
        )
      }
    </div>
  )
}

SimilarPropertiesSection.propTypes = {
  propertySlugOrId: PropTypes.string,
}

export default SimilarPropertiesSection
